import styled from 'styled-components';

import { theme, PictogramRegularLoyaltyPoint } from '@notino/react-styleguide';

export const gradientMagenta12 = `${theme.color.common.magenta50}12`;
export const gradientNude12 = `${theme.color.loyalty.nude60}12`;
export const gradientBlue05 = `${theme.color.loyalty.nude60}05`;
export const gradientNude05 = `${theme.color.loyalty.nude60}05`;

export const SLoyaltyBackground = styled.div`
  background: linear-gradient(88.2deg, ${gradientMagenta12} 2.05%, ${gradientNude12} 96.96%),
    linear-gradient(88.57deg, ${gradientBlue05} 1.57%, ${gradientNude05} 96.8%), ${theme.color.common.white};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
`;

export const SLoyaltyPoint = styled(PictogramRegularLoyaltyPoint)`
  width: 1rem !important;
  height: 1rem !important;
  margin-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  flex-shrink: 0;
`;
